import { render, staticRenderFns } from "./bCategoryIndex.vue?vue&type=template&id=20d3de75&scoped=true"
import script from "./bCategoryIndex.vue?vue&type=script&lang=js"
export * from "./bCategoryIndex.vue?vue&type=script&lang=js"
import style0 from "./bCategoryIndex.vue?vue&type=style&index=0&id=20d3de75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3de75",
  null
  
)

export default component.exports